module.exports = __webpack_public_path__ + "img/redux.b5ed66c6.jpg";